var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"element",attrs:{"type":"checkbox"}},'input',Object.assign({}, ( _vm.defaultValue === true && {
            checked: true
        }),
        ( !_vm.allowFilling && { disabled: true })),false),Object.assign({}, ( _vm.allowFilling && {
            change: _vm.action
        }))))}
var staticRenderFns = []

export { render, staticRenderFns }